/**
 * @generated SignedSource<<1824c9271a105b94062b9c6f7756b739>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeaturedEventsFragment_club$data = {
  readonly copyOverrides: {
    readonly event: {
      readonly plural: string;
    } | null | undefined;
  } | null | undefined;
  readonly departments: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly anyFacilityEventsEnabled: boolean;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly featuredEvents: {
    readonly count: number;
    readonly " $fragmentSpreads": FragmentRefs<"EventsList_EventsConnection">;
  } | null | undefined;
  readonly nonFeaturedEvents: {
    readonly count: number;
    readonly " $fragmentSpreads": FragmentRefs<"EventsList_EventsConnection">;
  } | null | undefined;
  readonly " $fragmentType": "FeaturedEventsFragment_club";
};
export type FeaturedEventsFragment_club$key = {
  readonly " $data"?: FeaturedEventsFragment_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeaturedEventsFragment_club">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "dateGte",
  "variableName": "dateGTE"
},
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "EventsList_EventsConnection"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dateGTE"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeaturedEventsFragment_club",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DepartmentConnection",
      "kind": "LinkedField",
      "name": "departments",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DepartmentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Department",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "anyFacilityEventsEnabled",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClubCopyOverrides",
      "kind": "LinkedField",
      "name": "copyOverrides",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NounOverride",
          "kind": "LinkedField",
          "name": "event",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plural",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "featuredEvents",
      "args": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "kind": "Literal",
          "name": "isFeatured",
          "value": true
        }
      ],
      "concreteType": "EventConnection",
      "kind": "LinkedField",
      "name": "events",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": "nonFeaturedEvents",
      "args": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "kind": "Literal",
          "name": "isFeatured",
          "value": false
        }
      ],
      "concreteType": "EventConnection",
      "kind": "LinkedField",
      "name": "events",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Club",
  "abstractKey": null
};
})();

(node as any).hash = "7a1c16302d46a698a9312ecfe44fd6b0";

export default node;
